import Vue from "vue";

import {PersonnelService,} from "@/common/api.service";
import {CANCEL_PERSON_ADDRESS_EDIT_STATE, DELETE_ADDRESS, FETCH_PERSON_ADDRESS, SAVE_ADDRESS, SAVE_PERSON_ADDRESS, UPDATE_ADDRESS,} from "./actions.js";
import {
    FETCH_PERSON_ADDRESS_END,
    LOAD_PERSON_ADDRESS_TO_EDIT,
    RESET_DEFAULT_ADDRESS_TO_EDIT,
    RESET_DEFAULT_PERSON_ADDRESS_TO_EDIT,
    TOGGLE_EDIT_PERSON_ADDRESS_DIALOG,
    TOGGLE_PERSON_ADDRESS_EDIT_STATE,
    UPDATE_NEW_PERSON_ADDRESS,
    UPDATE_PERSON_ADDRESS_FIELD
} from "./mutations.js";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        personAddress: {},
        personAddressList: [],
        editStatePersonAddress: {
            addressLineOne: false,
            addressLineTwo: false,
            town: false,
            county: false,
            postCode: false,
            country: false,
            comments: false,
            emailAddressPersonal: false,
            phoneNumber: false,
            longitude: '',
            latitude: ''
        },
        editPersonAddress: {
            fiscalYear: 2019,
            carriedOver: 0,
            yearlyEntitlement: 0,
            specialAllowance: 0,
            comments: '',
            holidayPeriod: 1,
        },
        defaultPersonAddress: {
            fiscalYear: 2019,
            carriedOver: 0,
            yearlyEntitlement: 0,
            specialAllowance: 0,
            comments: '',
            holidayPeriod: 1,
        },
        editPersonAddressDialog: false,
    }
};

const state = getDefaultState();

const getters = {
    editPersonAddressId(state) {
        if (state.editPersonAddress !== undefined) {
            return state.editPersonAddress.personId;
        }
    },
    editPersonAddressDialog(state) {
        return state.editPersonAddressDialog;
    },
    personAddress(state) {
        return state.personAddress;
    },
    editStatePersonAddress(state) {
        return state.editStatePersonAddress;
    },
};

const actions = {
    [FETCH_PERSON_ADDRESS]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonAddress(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_ADDRESS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch address'});
            });
    },
    [CANCEL_PERSON_ADDRESS_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_ADDRESS, params.personId);
        commit(TOGGLE_PERSON_ADDRESS_EDIT_STATE, params.field);
    },
    [SAVE_ADDRESS]({state, commit, dispatch}, personId) {
        state.editPersonAddress.personId = personId;
        return PersonnelService.savePersonAddress(state.editPersonAddress)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_ADDRESS_TO_EDIT);
                dispatch(FETCH_PERSON_ADDRESS, personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save address'});
            });
    },

    [UPDATE_ADDRESS]({commit, dispatch}, params) {
        return PersonnelService.updatePersonAddress(state.editPersonAddress)
            .then(({data}) => {
                commit(RESET_DEFAULT_ADDRESS_TO_EDIT);
                dispatch(FETCH_PERSON_ADDRESS, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update address'});
            });
    },

    [DELETE_ADDRESS]({commit, dispatch}, params) {
        return PersonnelService.deletePersonAddress(params.personAddressId)
            .then(({data}) => {
                dispatch(FETCH_PERSON_ADDRESS, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete address'});
            });
    },

    // Update
    [SAVE_PERSON_ADDRESS]({dispatch, commit}) {
        return PersonnelService.updatePersonAddress(state.editPersonAddress)
            .then(({data}) => {
                // commit(TOGGLE_PERSON_ADDRESS_EDIT_STATE, params.field);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                dispatch(FETCH_PERSON_ADDRESS, state.editPersonAddress.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update address'});
            });
    },
};


/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_EDIT_PERSON_ADDRESS_DIALOG](state) {
        state.editPersonAddressDialog = !state.editPersonAddressDialog;
    },

    [RESET_DEFAULT_PERSON_ADDRESS_TO_EDIT](state) {
        state.editPersonAddress = state.defaultPersonAddress;
    },
    [LOAD_PERSON_ADDRESS_TO_EDIT](state) {
        state.editPersonAddress = state.personAddress;
    },

    [TOGGLE_PERSON_ADDRESS_EDIT_STATE](state, field) {
        state.editStatePersonAddress[field] = !state.editStatePersonAddress[field];
    },
    [UPDATE_PERSON_ADDRESS_FIELD](state, data) {
        state.editPersonAddress[data.field] = data.value;
    },
    [UPDATE_NEW_PERSON_ADDRESS](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonAddress[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonAddress[data.key] = data.value;
        }
    },
    [FETCH_PERSON_ADDRESS_END](state, data) {
        state.personAddress = data[0];
        state.isLoading = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
